export default __webpack_public_path__ + "static/heroSectionBg-ad0010e432254bba0f13547d0a539128.mp4";